import { render, staticRenderFns } from "./IconImage.vue?vue&type=template&id=1c54c969&scoped=true&lang=pug"
import script from "./IconImage.vue?vue&type=script&lang=js"
export * from "./IconImage.vue?vue&type=script&lang=js"
import style0 from "./IconImage.vue?vue&type=style&index=0&id=1c54c969&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c54c969",
  null
  
)

export default component.exports